<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.orders.retrieveLoader">
      <v-boilerplate type="table-heading, list-item-two-line" />
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <v-row align="center" justify="start" no-gutters>
              <router-link class="subtitle-1 routerLink font-weight-medium" :to="{name: 'OrderList'}">Órdenes</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium d-inline-block text-truncate" :style="$vuetify.breakpoint.width < 1200 ? 'max-width: 200px;' : 'max-width: 300px;'">{{instance.document.name}} para {{instance.customer.name}}</span>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-1" @click="modalReminder=true" outlined color="secondary"><v-icon small left>mdi-email</v-icon>Enviar orden</v-btn>
              <v-btn class="ml-1" @click="renderDocument('orders')" outlined color="secondary" retain-focus-on-click><v-icon small left>mdi-file-document</v-icon>PDF</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <v-row class="mx-0 background">
            <v-col cols="2">
              <span class="d-block mb-1">Total</span>
              <span class="body-1 font-weight-medium mr-1">{{instance.amount | currency(instance.currency)}}</span>
              <span>{{instance.currency}}</span>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="3" class="ml-2">
              <span class="d-block mb-1">Cliente</span>
              <v-btn :to="{name:'CustomerRetrieveUpdate', params:{id: instance.customer.id}}" v-if="instance.customer" height="20" text color="primary" retain-focus-on-click :ripple="false">
                <span class="d-inline-block text-truncate" style="max-width: 200px;">{{instance.customer.name}}</span>
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
              <span class="font-italic text--disabled" v-else>Cliente no especificado</span>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="2" class="ml-2">
              <span class="d-block mb-1">Fecha</span>
              <div class="font-weight-medium mt-1">{{instance.date | date}}</div>
            </v-col>
          </v-row>
          <v-divider />

          <!-- reminders -->
          <template v-if="messagesList.length">
            <v-col v-for="(d, i) in messagesList" :key="i">
              <v-icon class="mx-1" color="secondary" small>mdi-email-mark-as-unread</v-icon>
              <span>
                La orden fue enviada a {{d.recipient[0]}}
                <template v-if="d.recipient.length > 1">y otros {{d.recipient.length - 1}} contactos</template>
              </span>
              <span>{{d.created | dateTime}} por {{d.user}}</span>
            </v-col>
            <v-divider />
          </template>
          <!-- end reminders -->

          <v-toolbar class="transparent" flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Información general</v-toolbar-title>
          </v-toolbar>
          <v-row>
            <v-col cols="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Tipo de documento</v-list-item-title>
                  <v-list-item-subtitle>{{instance.document.name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Número</v-list-item-title>
                  <v-list-item-subtitle>{{instance.number}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Tipo de despacho</v-list-item-title>
                  <v-list-item-subtitle>{{instance.shipping_type}}</v-list-item-subtitle>
                </v-list-item>
                 <v-list-item>
                  <v-list-item-title>Dirección del envío</v-list-item-title>
                  <v-list-item-subtitle v-if="instance.address">{{instance.address}}</v-list-item-subtitle>
                  <v-list-item-subtitle class="font-italic text--disabled" v-else>No especificado</v-list-item-subtitle>
                </v-list-item>
                 <v-list-item v-if="instance.note">
                  <v-list-item-title>Nota</v-list-item-title>
                  <v-list-item-subtitle>{{instance.note}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Nombre del conductor</v-list-item-title>
                  <v-list-item-subtitle v-if="instance.carrier_name">{{instance.carrier_name}}</v-list-item-subtitle>
                  <v-list-item-subtitle class="font-italic text--disabled" v-else>No especificado</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>ID del conductor</v-list-item-title>
                  <v-list-item-subtitle v-if="instance.carrier_id">{{instance.carrier_id}}</v-list-item-subtitle>
                  <v-list-item-subtitle class="font-italic text--disabled" v-else>No especificado</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Patente del transporte</v-list-item-title>
                  <v-list-item-subtitle v-if="instance.licence_plate">{{instance.licence_plate}}</v-list-item-subtitle>
                  <v-list-item-subtitle class="font-italic text--disabled" v-else>No especificado</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- SII management -->
      <v-card class="px-0 my-5" v-if="account.country.id == 'CL' && instance.document.has_local_format">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Gestión SII</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-menu offset-y left transition="scale-transition" min-width="160px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" retain-focus-on-click outlined color="secondary">Acciones</v-btn>
                </template>
                <template v-if="instance.local_file">
                  <v-btn class="mr-1" :href="instance.local_file" target="_blank" block outlined retain-focus-on-click color="secondary">Descargar XML</v-btn>
                </template>
              </v-menu>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 background">
          <v-row>
            <v-col cols="8">
              <v-list class="v-list-form transparent">
                <v-list-item>
                  <v-list-item-title>Estado</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-btn v-if="!instance.tax_agency.cl_status" @click="taxAgencyService('orders', 'orders', 'tax_agency_status')" :loading="taxAgencyLoader" text color="primary" :ripple="false">Actualizar estado</v-btn>
                    <v-chip v-else-if="instance.tax_agency.cl_status.includes('Rechazado')" class="caption" color="defaultGrey" text-color="secondary" small>{{instance.tax_agency.cl_status}}<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
                    <v-chip v-else color="lightBlue" text-color="primary" small>{{instance.tax_agency.cl_status}}<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item v-if="instance.tax_agency.cl_status_detail">
                  <v-list-item-title>Detalle del estado</v-list-item-title>
                  <v-list-item-subtitle>{{instance.tax_agency.cl_status_detail}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    Track ID
                    <v-tooltip v-if="!instance.tax_agency.cl_id" right transition="scale-transition">
                      <template v-slot:activator="{on}">
                        <v-icon v-on="on" small color="red">mdi-alert</v-icon>
                      </template>
                      <span>Es requerido enviar a la agencia fiscal</span>
                    </v-tooltip>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-left">
                    <span v-if="instance.tax_agency.cl_id">{{instance.tax_agency.cl_id}}</span>
                    <span v-else><v-btn @click="taxAgencyService('orders', 'orders', 'tax_agency_send')" :loading="taxAgencyLoader" text color="primary" :ripple="false">Enviar a la agencia fiscal</v-btn></span>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Referencias</v-list-item-title>
                  <v-list-item-subtitle>
                    <template v-if="instance.references && instance.references.length">
                      <span class="d-block" v-for="d in instance.references" :key="d.document">• Documento tipo {{d.document}} del {{d.date | date}} ID {{d.serial}}. {{d.description}}</span>
                    </template>
                    <span class="font-italic text--disabled" v-else>No se especificaron referencias a documentos.</span>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- end SII management -->

      <v-card class="pa-0 my-5">
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Detalle</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Producto</th>
                  <th class="text-center">Unidad de medida</th>
                  <th class="text-right">Cantidad</th>
                  <th class="text-right">P. unitario</th>
                  <th class="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="d in instance.lines">
                  <tr :key="d.id">
                    <td>
                      <span class="body-1 text--secondary font-weight-medium">{{d.name}}</span>
                      <span class="d-block">{{d.description}}</span>
                    </td>
                    <td class="text-center">{{d.unit}}</td>
                    <td class="text-right">{{d.quantity}}</td>
                    <td class="text-right">
                      <span class="text--secondary font-weight-medium">{{d.amount | currency(instance.currency)}}</span>
                    </td>
                    <td class="text-right">
                      <span class="body-2 text--secondary font-weight-medium">{{d.total | currency(instance.currency)}} {{instance.currency}}</span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider />
          <!-- summary -->
          <v-row align="center" justify="end">
            <v-col cols="4">
              <v-list class="v-list-form pa-0 transparent">
                <v-list-item class="py-1">
                  <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Exento</v-list-item-title>
                  <v-list-item-subtitle class="text-right">{{instance.exempt | currency(instance.currency)}}</v-list-item-subtitle>
                </v-list-item>
                <template v-if="instance.document.has_taxes && instance.document.has_taxes_detail">
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Neto</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{instance.amount | currency(instance.currency)}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-divider class="ml-4 my-3" />
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Impuestos ({{instance.tax_percent}}%)</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{instance.tax | currency(instance.currency)}}</v-list-item-subtitle>
                  </v-list-item>
                </template>
                <v-divider class="ml-4 my-3" />
                <v-list-item class="py-1">
                  <v-list-item-title class="text-left body-1 text--secondary font-weight-medium">Total</v-list-item-title>
                  <v-list-item-subtitle class="text-right body-1 text--secondary font-weight-medium">{{instance.total | currency(instance.currency)}} {{instance.currency}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <!-- end summary -->
        </v-card-text>
      </v-card>
    </v-col>

    <!-- modal reminder -->
    <v-dialog v-model="modalReminder" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Enviar orden</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="modalReminder=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-subtitle class="py-2 px-3 background">
          <v-row align="center" no-gutters>
            <v-col cols="12">
              <v-autocomplete class="mx-0" v-model="$v.reminder.recipient.$model" :items="contactsList.concat({ name: 'Email de facturación', email: instance.customer.email })" :error="$v.reminder.recipient.$error" prefix="Para" small-chips deletable-chips :hide-details="!$v.reminder.recipient.$error" required multiple chips item-text="name" item-value="email"
                hint="Selecciona al menos un destinatario" no-data-text="No existen contactos asociados al cliente" persistent-hint autofocus dense outlined color="blue-grey lighten-2" background-color="white">
                <template v-slot:item="data">{{data.item.name}} ({{data.item.email}})</template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters>
            <v-col cols="12">
              <v-text-field class="mx-0" v-model="$v.reminder.subject.$model" :error="$v.reminder.subject.$error" prefix="Asunto" background-color="white" outlined required single-line dense maxlength="60" hint="Escribe un asunto para el mensaje" persistent-hint :hide-details="!$v.reminder.subject.$error" />
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-divider />
        <v-card-text>
          <v-row class="mx-0 py-5" align="center" justify="center">
            <v-col cols="10">
              <reminder-order-email :instance="instance" :template="account.email_template" :color-background="account.color_background" @update:message="reminder.message=$event" :message.sync="reminder.message" />
            </v-col>
          </v-row>
          <v-row class="mx-0 pb-2" justify="center">
            <v-col cols="10">
              <span class="mr-2 body-2 text--secondary">Archivos adjuntos</span>
              <v-chip class="ma-1" color="secondary" small outlined><v-icon left small>mdi-paperclip</v-icon>{{instance.number}}.pdf</v-chip>
              <v-chip class="ma-1" v-if="instance.local_file" color="secondary" small outlined><v-icon left small>mdi-paperclip</v-icon>{{instance.number}}.xml</v-chip>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn @click="modalReminder=false" outlined>Cancelar</v-btn>
          <v-btn @click="createReminder" :loading="$store.state.reminders.createLoader" color="primary">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end modal reminder -->

    <!-- modal pdf -->
    <v-dialog v-model="modalRender" v-if="instance.id" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">{{`PDF ${instance.document.name} Nº ${instance.number}`}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="modalRender=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row v-if="loaderRender">
            <v-col cols="12" class="py-0 ma-0">
              <v-skeleton-loader class="rounded-0" transition="fade-transition" type="table" />
            </v-col>
          </v-row>
          <v-row v-else-if="!loaderRender && !renderUrl">
            <v-col cols="12" class="py-16 text-center">
              <v-icon class="d-block" color="secondary" size="70">mdi-image-broken-variant</v-icon>
              <span class="d-block subtitle-1">PDF no disponible</span>
            </v-col>
          </v-row>
          <div id="render"></div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn :href="renderUrl" :download="`${instance.document.id}_N${instance.number}`" color="primary" dark>Descargar PDF</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end modal pdf -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import PaymentList from '@/components/payments/PaymentList'
import ReminderOrderEmail from '@/components/reminders/orders/Email'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import RenderViewMixin from '@/mixins/RenderViewMixin'
import TaxAgencyViewMixin from '@/mixins/TaxAgencyViewMixin'
import cloneDeep from 'lodash/cloneDeep'
export default {
  mixins: [
    GenericViewMixin,
    RenderViewMixin,
    TaxAgencyViewMixin
  ],
  inject: ['theme'],
  components: {
    PaymentList,
    ReminderOrderEmail,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({
    reminder: {
      template: '',
      recipient: '',
      subject: '',
      message: `Enviar la order`
    },
    shippingTypes: [
      { value: '1', label: 'Operación constituye venta' },
      { value: '2', label: 'Ventas por efectuar' },
      { value: '3', label: 'Consignaciones' },
      { value: '4', label: 'Entrega gratuita' },
      { value: '5', label: 'Traslados internos' },
      { value: '6', label: 'Otros traslados no venta' },
      { value: '7', label: 'Guía de devolución' },
      { value: '8', label: 'Traslado para exportación. (no venta)' },
      { value: '9', label: 'Venta para exportación' }
    ],
    modalReminder: false
  }),
  computed: mapState({
    instance: state => cloneDeep(state.orders.ordersDetail),
    messagesList: state => state.reminders.messagesList,
    contactsList: state => state.customers.contactsList
  }),
  created () {
    this.retrieve()
  },
  methods: {
    retrieve () {
      this.$store.dispatch('orders/RETRIEVE', {
        resource: 'orders',
        id: this.$route.params.id
      })
      .then(() => {
        this.instance.shipping_type = this.shippingTypes.find(type => type.value === this.instance.shipping_type).label
        this.$store.dispatch('reminders/LIST', {
          resource: 'reminders/messages',
          query: {
            order: this.instance.id
          }
        })
        this.$store.dispatch('customers/LIST', {
          resource: 'contacts',
          query: {
            customer: this.instance.customer.id
          }
        })
      })
    },
    createReminder () {
      this.reminder.order = this.instance.id
      this.$v.reminder.$touch()
      if (this.$v.reminder.$invalid) {
        return false
      }
      this.$store.dispatch('reminders/CREATE', {
        resource: 'reminders/messages',
        payload: this.reminder
      })
      .then(() => {
        this.modalReminder = false
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    remove (item) {
      const index = this.$v.reminder.recipient.$model.indexOf(item.name)
      if (index >= 0) this.$v.reminder.recipient.$model.splice(index, 1)
    }
  },
  validations: {
    reminder: {
      recipient: {
        required,
        maxLength: maxLength(8)
      },
      subject: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(60)
      },
      message: {
        required
      }
    }
  }
}
</script>